import * as React from 'react';
import {createTheme, ThemeProvider, Box, Typography, Tabs, Tab} from '@mui/material';
import AdminConfigs from './AdminConfigs';
import SeasonConfigs from './SeasonConfigs';
import SysAdmins from './SysAdmins';

function Admin() {
  const [tabSelection, setTabSelection] = React.useState('adminConfigs');
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
    typography: {
      button: {
        textTransform: 'none'
      }
    }
  });
  return <ThemeProvider theme={darkTheme}>
    <Box>
      <Typography variant="h4" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>
        CAPSized Admin Tools
      </Typography>
      <Tabs value={tabSelection} onChange={(event, value) => setTabSelection(value)} aria-label="basic tabs example">
        <Tab label="Admin Configs" value='adminConfigs' />
        <Tab label="Season Configs" value='seasonConfigs' />
        <Tab label="Modify System Admins" value='sysAdmins' />
      </Tabs>
      <br />
      {tabSelection === 'adminConfigs' && 
        <AdminConfigs />
      }
      {tabSelection === 'seasonConfigs' && 
        <SeasonConfigs />
      }
      {tabSelection === 'sysAdmins' && 
        <SysAdmins />
      }
    </Box>
  </ThemeProvider>
}

export default Admin;
